import { FC, PropsWithChildren, type JSX } from 'react';

import { Button } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';

import './ProgressiveDisclosure.sass';

type Props = {
  isRevealed: boolean;
  setIsRevealed: () => void;
  showCloseButton?: boolean;
  title: string;
};
const ProgressiveDisclosure: FC<PropsWithChildren<Props>> = ({
  children,
  isRevealed,
  setIsRevealed,
  showCloseButton = false,
  title,
}: PropsWithChildren<Props>): JSX.Element => {
  return (
    <div className={`progressive-disclosure${isRevealed ? ' revealed' : ''}`}>
      <Button variant="link" onClick={setIsRevealed} className="reveal-button">
        {title}
      </Button>
      <div className="body">
        {showCloseButton && (
          <Button aria-label="Close" variant="secondary">
            <UntitledIcon name="x.3" className="h-3.5 w-3.5" />
          </Button>
        )}
        {children}
      </div>
    </div>
  );
};

export default ProgressiveDisclosure;
